import { render, staticRenderFns } from "./TradeInForNew.vue?vue&type=template&id=237769ef&scoped=true"
import script from "./TradeInForNew.vue?vue&type=script&lang=js"
export * from "./TradeInForNew.vue?vue&type=script&lang=js"
import style0 from "./TradeInForNew.vue?vue&type=style&index=0&id=237769ef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237769ef",
  null
  
)

export default component.exports